import { useLocation } from '@gatsbyjs/reach-router';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { cookieConsentStateAtom } from '~/components/organism/CookieBanner/state';
import { trackEvent } from '~/components/organism/CookieBanner/utils/initializeAnalytics';

const usePageTracking = () => {
  const consentState = useRecoilValue(cookieConsentStateAtom);
  const location = useLocation();

  useEffect(() => {
    if (consentState.analytics_storage === 'denied') return;

    trackEvent({
      eventName: 'page_view',
      parameters: {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      },
    });
  }, [location.pathname, location.search, consentState.analytics_storage]);
};

export default usePageTracking;
